module.exports = __webpack_public_path__ + "static/media/icon-signed-form-view.9ec77e86.svg";